import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@material-ui/core';
import ListingPickerDialog from './ListingPickerDialog';

const AssociationDialog = ({
  open,
  file,
  cottages,
  counts,
  maxCount,
  isUpdating,
  onSave,
  onClose,
}) => {
  const normalizedFile = file
    ? {
        name: file.display_name || file.filename || '',
        mimeType: file.mime_type,
        sizeBytes: file.size_bytes,
        previewUrl: file.url || null,
      }
    : null;

  return (
    <ListingPickerDialog
      open={open}
      cottages={cottages}
      counts={counts}
      maxCount={maxCount}
      initialListingIds={file ? file.listing_ids : []}
      disabled={isUpdating}
      file={normalizedFile}
      onClose={onClose}
      actions={(listingIds) => (
        <>
          <Button onClick={onClose} disabled={isUpdating}>
            <FormattedMessage id="Cancel" defaultMessage="Cancel" />
          </Button>
          <Button
            onClick={() => onSave({ listing_ids: listingIds })}
            color="primary"
            disabled={isUpdating || listingIds.length === 0}
          >
            <FormattedMessage id="Save" defaultMessage="Save" />
          </Button>
        </>
      )}
    />
  );
};

AssociationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  file: PropTypes.shape({
    display_name: PropTypes.string,
    filename: PropTypes.string,
    mime_type: PropTypes.string,
    url: PropTypes.string,
    size_bytes: PropTypes.number,
    listing_ids: PropTypes.arrayOf(PropTypes.number),
  }),
  cottages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title_sv: PropTypes.string,
    }),
  ).isRequired,
  counts: PropTypes.shape({
    listings: PropTypes.shape({}),
  }),
  maxCount: PropTypes.number.isRequired,
  isUpdating: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AssociationDialog;
